import { off, onValue, ref } from "firebase/database";
import { EVENT_PATH } from "../../../services/firebaseService/storagePaths";
import { database } from "../../../services/firebaseService/firebaseConfig";

const SPONSOR_PATH = "Sponsors";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const syncSponsorsForEvent = (eventId: string, callback: any) => {
  const dbRef = ref(database, `${EVENT_PATH}/${eventId}/${SPONSOR_PATH}`);

  off(dbRef);
  onValue(dbRef, (snap) => {
    const sponsors = snap.val();

    if (callback) {
      callback(sponsors);
    }
  });
};
